import { createAction, createRequestTypes, FAILURE, REQUEST, SUCCESS } from '../../../utils/actionGenerator';

export const GET_FORM_CONFIG = createRequestTypes('GET_FORM_CONFIG');
export const GET_CONSIGNER_LIST = createRequestTypes('GET_CONSIGNER_LIST');
export const GET_START_ADDRESS = createRequestTypes('GET_START_ADDRESS');
export const GET_END_ADDRESS = createRequestTypes('GET_END_ADDRESS');
export const CREATE_DEMAND = createRequestTypes('CREATE_DEMAND');
export const ADD_ADDRESS = createRequestTypes('ADD_ADDRESS');
export const GET_VIA_POINTS_SUGGESTIONS = createRequestTypes('GET_VIA_POINTS_SUGGESTIONS');

export const getFormConfig = {
  request: () => createAction(GET_FORM_CONFIG[REQUEST]),
  success: (response) => createAction(GET_FORM_CONFIG[SUCCESS], { response }),
  failure: (response) => createAction(GET_FORM_CONFIG[FAILURE], { response }),
};

export const getConsignerSuggestions = {
  request: (payload) => createAction(GET_CONSIGNER_LIST[REQUEST], { payload }),
  success: (response) => createAction(GET_CONSIGNER_LIST[SUCCESS], { response }),
  failure: (response) => createAction(GET_CONSIGNER_LIST[FAILURE], { response }),
};

export const getViaPointsSuggestions = {
  request: (params) => createAction(GET_VIA_POINTS_SUGGESTIONS[REQUEST], { params }),
  success: (response) => createAction(GET_VIA_POINTS_SUGGESTIONS[SUCCESS], { response }),
  failure: (response) => createAction(GET_VIA_POINTS_SUGGESTIONS[FAILURE], { response }),
};

export const getStartAddresses = {
  request: (payload) => createAction(GET_START_ADDRESS[REQUEST], { payload }),
  success: (response) => createAction(GET_START_ADDRESS[SUCCESS], { response }),
  failure: (response) => createAction(GET_START_ADDRESS[FAILURE], { response }),
};

export const getEndAddresses = {
  request: (payload) => createAction(GET_END_ADDRESS[REQUEST], { payload }),
  success: (response) => createAction(GET_END_ADDRESS[SUCCESS], { response }),
  failure: (response) => createAction(GET_END_ADDRESS[FAILURE], { response }),
};

export const createDemand = {
  request: (payload) => createAction(CREATE_DEMAND[REQUEST], { payload }),
  success: (response) => createAction(CREATE_DEMAND[SUCCESS], { response }),
  failure: (response) => createAction(CREATE_DEMAND[FAILURE], { response }),
};

export const addAddressDemand = {
  request: (payload) => createAction(ADD_ADDRESS[REQUEST], { payload }),
  success: (response) => createAction(ADD_ADDRESS[SUCCESS], { response }),
  failure: (response) => createAction(ADD_ADDRESS[FAILURE], { response }),
};
